/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React from 'react';

import { VodItemType } from 'client-code/vod-browse';

import './GalleryGridSkeleton.scss';

interface GalleryGridSkeletonProps {
    count: number;
    columns: number;
    vodType?: string;
    className?: string;
    horizontalGap?: string;
    verticalGap?: string;
    padding?: string;
}

const GalleryGridSkeleton: React.FC<GalleryGridSkeletonProps> = ({
    count,
    columns,
    vodType = '',
    className = '',
    horizontalGap = '0.83vw', // 16px
    verticalGap = '1.48vh', // 16px
    padding = '0.31vw', // 6px
}) => {
    return (
        <div
            className={`gallery-skeleton-grid ${className}`}
            style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: `${verticalGap} ${horizontalGap}`,
                padding: `${padding}`,
            }}
        >
            {Array.from({ length: count }).map((_, idx) => (
                <div
                    key={idx}
                    className={`${vodType === VodItemType.MovieVodItem ? `movie-gallery-item` : 'episode-gallery-item'} gallery-skeleton-tile`}
                />
            ))}
        </div>
    );
};

export default GalleryGridSkeleton;
